import { AxiosError, AxiosInstance } from 'axios';
import { ROUTES } from 'config';
import { localStorageManager } from 'services/localStorage';
import { pushToDataLayer } from 'utils/analytics';

export const setResponseInterceptor = (instance: AxiosInstance) => {
  return instance.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      const status = error.response?.status;
      const currentPath = window?.location?.pathname ?? '';

      if (status === 401 && currentPath !== ROUTES.login) {
        localStorageManager.clearStorage();
        window.location.href = ROUTES.login;
        return Promise.reject(error);
      }

      pushToDataLayer({
        event: 'api_error',
        event_time: new Date().toISOString(),
        error_status: status,
        error_url: error.config?.url ?? 'unknown',
        error_method: (error.config?.method ?? 'unknown').toUpperCase(),
      });

      return Promise.reject(error);
    },
  );
};

export const setInterceptors = (instance: AxiosInstance): void => {
  setResponseInterceptor(instance);
};
